import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const i = ".sc-inbox-icon-h{display:flex}", e = i, h = class {
  constructor(o) {
    s(this, o), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "f622d58c8091755178623f15985d32c682a1d3df", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "0981a256ec75e220389453840c2f24c4936e016e", d: "M20 3H4C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3Z", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "31cc25a306684bfaf465b3a431575b66223ba4b0", d: "M2 5L12 12.5L22 5", stroke: "auto", "stroke-width": "1.5" }));
  }
};
h.style = e;
export {
  h as inbox_icon
};
